import type { HallPatrolAction } from "./hallPatrol";

export type HallPatrolM2Surface = "worker" | "feeding" | "task" | "breeding" | "deferred";

export type WorkerOperationKind =
  | "water_measurement"
  | "water_change"
  | "siphon"
  | "health_observation"
  | "mortality"
  | "treatment";

const WORKER_OPERATION_ACTIONS: Readonly<Record<string, WorkerOperationKind>> = {
  water_measurement: "water_measurement",
  water_change: "water_change",
  siphon: "siphon",
  health_observation: "health_observation",
  mortality: "mortality",
  treatment: "treatment",
};

export function workerOperationKindForHallPatrolAction(
  action: HallPatrolAction,
): WorkerOperationKind | undefined {
  return WORKER_OPERATION_ACTIONS[action];
}

export function hallPatrolM2Surface(action: HallPatrolAction): HallPatrolM2Surface {
  if (workerOperationKindForHallPatrolAction(action)) return "worker";
  if (action === "feeding_record") return "feeding";
  if (action === "task_complete") return "task";
  if (
    action === "spawn_record" ||
    action === "egg_result_record" ||
    action === "free_swim_record" ||
    action === "parent_feeding_record" ||
    action === "parent_separation_record" ||
    action === "growout_record"
  ) {
    return "breeding";
  }
  return "deferred";
}
